module.exports = __webpack_public_path__ + "img/logo-light.c0a6f030.svg";